<template>
  <div class="cls_not_found">
    <el-image :src="require('@/assets/images/404.png')" style="margin:auto"></el-image>
    <el-button size="medium" type="primary" @click="back">返回</el-button>
  </div>
</template>

<script>
export default {
    name: 'NotFound',
    methods:{
        back(){
            this.$router.back()
        }
    }
}
</script>

<style scoped>
.cls_not_found{
    width: 45%;
    height: 45%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
</style>